var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTooltipIcn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2426_16379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6119 12.961C18.302 11.2709 21.0422 11.2709 22.7323 12.961C24.4224 14.6511 24.4224 17.3913 22.7323 19.0814C22.7215 19.0922 22.7107 19.1029 22.6998 19.1136L15.9999 25.8134L9.30033 19.1138L9.26759 19.0814C7.57747 17.3913 7.57747 14.6511 9.26759 12.961C10.9577 11.2709 13.6983 11.2709 15.3884 12.961L15.9999 13.5725L16.6119 12.961ZM16.6119 12.961C16.6118 12.961 16.6119 12.9609 16.6119 12.961ZM12.5391 11.1261V8.96225C12.5391 7.0501 14.0892 5.5 16.0013 5.5C17.9135 5.5 19.4636 7.0501 19.4636 8.96225V11.1261",
    stroke: "#1D1DFF",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2426_16379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIcn);
export default __webpack_public_path__ + "static/media/Tooltip-ICN.ea533db99ccc34c4cd2f34e68dc8e126.svg";
export { ForwardRef as ReactComponent };